import React from "react"
import { useMantineTheme } from "@mantine/core"
import { Button } from "@/components"
import { useToggleCopilotChat } from "@/components/CopilotAnalyze/hooks/useToggleCopilotChat"
import classes from "./styles.module.css"
import { Icon } from "@/components/Icon"

interface Props {
    popdownIsOpen?: boolean
}

export const CopilotMobileHomeButton = (props: Props) => {
    const { toggleChat } = useToggleCopilotChat()
    const theme = useMantineTheme()

    const handleClick = () => {
        toggleChat()

        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur()
        }
    }

    return (
        <div className={classes.pwaCopilotHomeButtonWrapper}>
            <Button
                variant="outline"
                classNames={{
                    root: classes.pwaCopilotHomeButton,
                    inner: classes.pwaCopilotHomeInnerButton,
                    label: classes.pwaCopilotHomeButtonLabel,
                    rightIcon: classes.pwaCopilotHomeButtonLabelRightIcon,
                }}
                leftIcon={<Icon icon="sparkles" iconFamily="far" color={theme.colors.violet[8]} />}
                rightIcon={<Icon icon="paper-plane-top" iconFamily="q" color={theme.colors.violet[8]} />}
                onClick={handleClick}
                data-plum-id="copilot-2-navbar-open"
                aria-label="Open Copilot Analyze"
            >
                Ask Copilot
            </Button>
        </div>
    )
}
